export const EventNames = {
  DeepLink: "deeplink",
  LevelHpOpened: "Level HP Opened",
  TopUpNowClick: "Top Up Now Clicked",
  CityContestFaqOpened: "City Contest FAQ Opened",
  CityContestFaqLinkOpened: "City Contest FAQ link Opened",
  CityContestClicked: "City Contest Clicked",
  CityContestRoomClicked: "City Contest Room Clicked",
  LeaderBoardRichOpened: "Leaderboard Rich Opened",
  LeaderBoardTrendingOpened: "Leaderboard Trending Opened",
  LeaderBoardCityContestOpened: "City Contest HP Opened",
  LeaderBoardTopFansOpened: "Top Fans Icon Clicked",
  LeaderBoardTopFansClosed: "Top Fans Dismissed",
  InfoIconClick: "Info Icon Clicked",
  AnonymousClicked: "Anonymous Icon Clicked",
  ViewProfile: "view_profile",
  OpenRoom: "open_room",
  ProfileVisit: "Profile_Visit",
  OpenBrowser: "open_browser",

  /**
   * /earnings page analytics
   */
  Earnings_Page_Displayed: "My Earnings Page Displayed",
  Daily_Reports_Clicked: "Daily Reports Icon Clicked",
  Daily_Reports_Displayed: "Daily Reports Page Displayed",
  Daily_Earnings_Viewed: "Daily Earnings Viewed ",
  Earnings_Date_Selected: "Earnings Date Selected",
  Earning_Info_Icon_Clicked: "Earning Info Icon Clicked",
  Wallet_Icon_Clicked: "My Wallet Icon Clicked",
  Wallet_Page_Displayed: "My Wallet Page Displayed",
  Face_Verification_Clicked: "Face Verification Icon Clicked",
  Mobile_Verification_Clicked: "Mobile Verification Icon Clicked",
  Withdrawal_History_Clicked: "Withdrawal History Icon Clicked",
  Withdrawal_History_Page_Displayed: "Withdrawal History Page Displayed",
  Withdrawal_Date_Selected: "Withdrawal Date Selected",
  ViewDiamonds: "view_diamonds",
  EarningPageOpenEditProfile: "ep_open_edit_profile",
  EarningPageOpenWallet: "ep_open_wallet",
  OpenLevelsPage: "open_levels",
  MCP_Page_Opened: "MCP Page Opened",
  MCP_Level_Icon_Clicked: "MCP Level Icon Clicked ",
  Withdrawal_Method_Selected: "Withdrawal Method Selected",

  GiftsReceivedPageOpen: "Gifts Received Page Open",
  GiftsSentPageOpen: "Gifts Sent Page Open",
  GiftsReceivedDetailedPageOpen: "Gifts Received Detailed Page Open",
  GiftsSentDetailedPageOpen: "Gifts Sent Detailed Page Open",
};
